import React from 'react'
import { Container, makeStyles, Typography } from '@material-ui/core'
import Carousel from './Carousel'
const useStyles= makeStyles({
  banner: {
     backgroundImage: 'url(./banner2.jpg)',
     height: '70vh'
  },
  bannerContent:{
    display:'flex',
    flexDirection:'column',
    height:'400vh',
    paddingTop:'25px',
    justifyContent:'space-arround'
  },
  tagline:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    textAlign:'center'
  }
})
const Banner = () => {
    const classes=useStyles()
  return (
    <>
    <div className={classes.banner} >
    <Container className={classes.bannerContent} >
     <div className={classes.tagline}>
      <Typography style={{
         fontWeight:'bold',
         marginBottom:'15px',
         textAlign:'center'
      }} variant='h2' >
        Crypto Tracker
      </Typography>
      <Typography style={{
         fontWeight:'bold',
         marginBottom:'15px',
         color:'grey',
         textAlign:'center'
      }} variant='subtitle2' >
        Get all the info regardign your favourite cryptocurrency
      </Typography>
     </div>
    </Container>
  </div>
   <Carousel/>
  </>
  )
}

export default Banner